import gql from "graphql-tag";

export const REGISTER_DEVICE = gql`
  mutation ($input: deviceRegisterInput!) {
    registerDevice(input: $input)
  }
`;
